export default {
  // 配置
  config: {
    lang: 'tw',
    name: ' 正體中文'
  },
  lang: {
    zh: '简体中文',
    en: 'English',
    tw: '正體中文'
  },
  index: {
    ios: 'App Store',
    android: 'Google Play',
    url: 'Download in PundiX.com',
    stayTuned: '敬請期待'
  },
  // 错误码
  errCode: {
    code: {
      200: 'success',
      300: 'not login',
      301: 'permission denied',
      400: 'param error',
      401: 'bad request',
      404: '接口地址错误',
      500: 'server error'
    },
    // 报错信息
    msg: {
      success: '成功',
      lose: '失败',
      yes: '确定',
      errConnect: '服务器连接失败'
      // 登陆超时，请重新登陆
    }
  },
  // 通用
  common: {
    noData: '暂无数据'
  }
}



// WEBPACK FOOTER //
// ./src/lang/tw.js